import axios from "axios"
import { showNotification } from "../../common/actions/notificationAction"
import { LOGOUT } from "../../common/actions/types"
import { api, unauthorizedApi } from "../../common/api/api"
import {
  LOAD_AUTH,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  CLEAN_AUTH,
} from "./types"

export const onLogin = (username, password) => (dispatch) => {
  unauthorizedApi
    .post("tenant/login", { username, password })
    .then((response) => {
      const { token } = response.data
      localStorage.setItem("token", token)
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          token: token,
        },
      })
    })
    .catch((err) => {
      const { error } = err.response.data
      dispatch({
        type: LOGIN_FAILURE,
        payload: {
          error: error,
        },
      })
      dispatch(showNotification("Αποτυχία σύνδεσης", error, "error"))
    })
}

export const getProfile = () => (dispatch) => {
  axios.all([
    api.get("profile"),
    api.get("tenant/employee/profile")
  ]).then(axios.spread((response1, response2) => {
    localStorage.setItem("profile", JSON.stringify(response1.data))
    localStorage.setItem("tenantProfile", JSON.stringify(response2.data))
    dispatch(loadAuth())
  }))
}

export const onLogout = () => (dispatch) => {
  localStorage.clear()
  window.location.replace(window.location.origin)

  dispatch({
    type: LOGOUT,
  })
}

export const loadAuth = () => (dispatch) => {
  const token = localStorage.getItem("token")

  const profile = localStorage.getItem("profile")
    ? JSON.parse(localStorage.getItem("profile"))
    : {}

  const tenantProfile = localStorage.getItem("tenantProfile")
    ? JSON.parse(localStorage.getItem("tenantProfile"))
    : {}

  dispatch({
    type: LOAD_AUTH,
    payload: {
      token: token,
      profile: profile,
      tenantProfile: tenantProfile
    },
  })
}

export const cleanAuth = () => (dispatch) => {
  dispatch({
    type: CLEAN_AUTH,
  })
}
